jQuery(document).ready(function ($) {
    $.fn.toggleFilterDropdown = function () {
        console.log('toggleFilterDropdown()');

        this.toggleClass('active');
        this.find('.archive__filters--dropdown').fadeToggle(500);
        return this;
    }

    $.fn.closeFilterDropdown = function () {
        console.log('closeFilterDropdown()');

        this.removeClass('active');
        this.find('.archive__filters--dropdown').fadeOut(500);
        return this;
    }

    $.fn.toggleSelect = function () {
        console.log('toggleSelect()');

        this.siblings().removeClass('selected');
        this.toggleClass('selected');

        const option = this.parent().parent().parent();
        const label = $(option.children().get(0));

        if (this.hasClass('selected')) {
            option.addClass('filtered');
            label.text(this.text());
        } else {
            option.removeClass('filtered');
            label.text(label.attr('data-default'));
        }

        return this;
    }

    $.fn.collectFilters = function () {
        console.log('collectFilters()');

        const filters = this.find('.archive__filters--option');

        let output = [];

        if ($('.archive__filters--option[data-option="category"]').length === 0) {
            const term_id = ($('body').attr('class')).match(/\w+:\d+/);

            output.push(term_id[0]);
        }

        filters.each(function () {
            const label = $(this).attr('data-option');
            const selected = $(this).find('.selected').attr('data-value');

            output.push(`${label}:${selected}`);
        });

        return output.join(',');
    }

    $.fn.getPosts = function (filters, page, append = false) {
        console.log('getPosts()');

        const ajax_data = {
            action: 'get_posts',
            nonce: blogs.nonce,
            filters: filters,
            page: page
        }

        const _this = this;

        $.ajax({
            url: blogs.ajax_url,
            type: 'POST',
            data: ajax_data,

            beforeSend: function () {
                $('.archive__filters--submit').setToLoading();
                $('.archive__post--load').setToLoading();
            },

            success: function (response) {
                $('.archive__post--load').attr('data-page', response.data.next_page);

                if (append) {
                    _this.append(response.data.posts);
                } else {
                    _this.html(response.data.posts);
                }

                if (parseInt(response.data.next_page) === 0) {
                    $('.archive__post--load').hide();
                } else {
                    $('.archive__post--load').show();
                }
            },

            complete: function () {
                $('.archive__filters--submit').returnToLoad();
                $('.archive__post--load').returnToLoad();
            }
        });

        return this;
    }

    $('.archive__filters').on('change', function (event) {
        const filters = $(this).collectFilters();

        $('.archive__posts--grid').getPosts(filters, 0);

        console.log(filters);
    });

    $('.archive__post--load').on('click', function (event) {
        event.preventDefault();

        const filters = $('.archive__filters').collectFilters();

        $(this).prev().getPosts(filters, $(this).attr('data-page'), true);
    });

    $('.archive__filters--submit').on('click', function (event) {
        event.preventDefault();

        $(this).parent().trigger('change');
    });

    $('.archive__filters--option').on('click', function (event) {
        $('.archive__filters--option').not(this).closeFilterDropdown();

        if (!($(event.target).hasClass('archive__filters--dropdown') || $(event.target).closest('.archive__filters--dropdown').length > 0)) {
            $(this).toggleFilterDropdown();
        }
    });

    $('.archive__filters--heading i').on('click', function (event) {
        $(this).parent().parent().parent().closeFilterDropdown();
    });

    $('.archive__filters--select').on('click', function (event) {
        $(this).toggleSelect();
    });

    $('.archive__filters--done').on('click', function (event) {
        $(this).parent().parent().closeFilterDropdown();
    });

    $('body').on('click', function (event) {
        if ($(event.target).closest('.archive__filters--option').length === 0) {
            $('.archive__filters--option').closeFilterDropdown();
        }
    });
});